// extracted by mini-css-extract-plugin
module.exports = {"infokort":"Infokort_infokort__v88cG"};